import React from "react";
//#region types
import { EditableFormInnerProps, GenericFormSection } from "models/propTypes/genericFormProps";
//#endregion
//#region components
import { Grid } from "@mui/material";
import useCheckVisibility from "./hooks/useCheckVisibility";
import useCheckHasErrors from "./hooks/useCheckHasErrors";
import useWizardDialogContext from "../wizardDialog/context/useWizardDialogContext";
import TabEvents from "../tabs/tabEvents";
import TabPanel from "../tabs/tabPanel";
import GenericFormInner from "./genericFormInner";
import cssExports from "theme/styles/main.module.scss";
import { useFormikContext } from "formik";
//#endregion

function EditableFormDialogWizard<T extends Record<string, any>>(props: EditableFormInnerProps<T>) {
  const { getFieldHidden } = useCheckVisibility<T>();
  const { getHasErrors } = useCheckHasErrors<T>(true);
  const { values } = useFormikContext();

  const fields = (props.fields as GenericFormSection<T>[])?.filter((field) => !getFieldHidden(field.hidden));
  const wizardContext = useWizardDialogContext();

  React.useEffect(() => {
    const hasErrors =
      wizardContext?.currentStep !== undefined ? getHasErrors(fields[wizardContext?.currentStep]) : false;
    wizardContext?.setCurrentStepErrors(hasErrors);
  }, [getHasErrors(fields[wizardContext?.currentStep ?? 0])]);

  React.useEffect(() => {
    values && wizardContext?.setValues(values);
  }, [values]);

  React.useEffect(() => {
    if (fields.length !== wizardContext?.numOfSteps) {
      wizardContext?.setNumOfSteps(fields.length);
      wizardContext?.setWizardFields(fields);
    }
  }, [fields]);

  return (
    <Grid container item direction="column" xs className={cssExports.tabsFormContainer}>
      <TabEvents
        render={(currentIndex, onTabChange, resetTabIndex) => (
          <React.Fragment>
            {fields.map((tab, index) => {
              return (
                <TabPanel key={index} value={wizardContext?.currentStep} index={index} className={tab.className}>
                  <Grid container>
                    <GenericFormInner<T>
                      {...props}
                      key={`genericFormInner-${index}`}
                      fields={tab.innerFields}
                      inline={tab.inline ?? props.inline}
                      enableControlLables={tab.enableControlLables ?? props.enableControlLables}
                      formGridLayout={tab.formGridLayout ?? props.formGridLayout}
                    />
                  </Grid>
                </TabPanel>
              );
            })}
          </React.Fragment>
        )}
      />
    </Grid>
  );
}

export default EditableFormDialogWizard;
